import{__require as r}from"../classes/range.js";const e=r();var a=(r,a)=>{try{return new e(r,a).range||"*"}catch(r){return null}};export{a as v};
